{
    "TeamsAuth_UserIntro": "Hoi {},",
    "TeamsAuth_UserIntro_2": "Akixi for MS Teams vraagt toegang tot je Microsoft Entra Tenant",
    "TeamsAuth_AdminConsent": "Toestemming verlenen",
    "TeamsAuth_Authorise": "Autoriseer",
    "TeamsAuth_ConsentedMessage": "Admin Toestemming verleend, klik op Toestaan om verder te gaan",
    "TeamsAuth_AuthorisedMessage": "Toestemming verleend",
    "TeamsAuth_Decline": "Daling",
    "TeamsAuth_Error_Unknown": "Er is een onherkende fout opgetreden. Probeer het opnieuw. Als het probleem zich blijft voordoen, neem dan contact op met uw systeembeheerder.",
    "NAME": "TeamsAuth"
}